/** Port von `IwmSharedColumnsDate.razor` — reiner Text ohne umgebendes Element. */

import { formatDate } from '@/utils/date';

export interface DateCellProps {
  value: string | Date | null | undefined;
}

export function DateCell(props: DateCellProps) {
  const text = formatDate(props.value);
  if (text === '') return null;
  return <>{text}</>;
}

export default DateCell;
